module.exports = __webpack_public_path__ + "img/2.11a9ceac.webp";